import { render, staticRenderFns } from "./m-confirm-button.vue?vue&type=template&id=d6d2c2a2&scoped=true"
import script from "./m-confirm-button.vue?vue&type=script&lang=js"
export * from "./m-confirm-button.vue?vue&type=script&lang=js"
import style0 from "./m-confirm-button.vue?vue&type=style&index=0&id=d6d2c2a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d2c2a2",
  null
  
)

export default component.exports